module.exports = __webpack_public_path__ + "img/form-2.c4885c0c.svg";